import { useEffect } from "react";
import { useNavigate } from "react-router";
import posthog from "posthog-js";

export const RedirectToDashboard = () => {
  const nav = useNavigate();
  useEffect(() => {
    posthog.capture("Redirecting from 404", {url: window.location.pathname} as any);
    nav("/auth/dashboard");
  }, []);
  console.log("Redirecting to dashboard");
  return <div></div>;
};
